import { Box } from '@mui/system';
import { CircularProgress } from '@mui/material';
import React from 'react';

/**
 * Spinner overlay that displays a spinner in the middle of the parent.
 * A gray overlay is displayed underneath the other layers so that the content is still interactable.
 * @param condition Boolean that hides or show the spinner
 * @returns {JSX.Element}
 * @constructor
 */
const OverlaySpinner = ({ condition = true, fixed = false }) => (
  condition && (
    <>
      <Box className="overlaySpinner-overlay" sx={{
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: -1,
      }} />
      { fixed ? (
        <Box className="overlaySpinner-wrapper" sx={{ position: 'relative', width: '100%', height: 0 }}>
          <Box className="overlaySpinner-spinner" sx={{
            position: 'absolute',
            top: '96px',
            left: '50%',
          }}>
            <CircularProgress sx={{ margin: 'auto auto' }}/>
          </Box>
        </Box>
      ) : (
        <Box className="overlaySpinner-spinner" sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
        }}>
          <CircularProgress sx={{ margin: 'auto auto' }}/>
        </Box>
      )}
    </>
  )
);

export default OverlaySpinner;
